"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_1 = require("./styled");
var Rainy = function (_a) {
    var children = _a.children, parentHeight = _a.parentHeight;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        Array.from({ length: 40 }).map(function (_, index) {
            return (react_1.default.createElement(styled_1.Rain, { preserveAspectRatio: "xMinYMin", viewBox: "0 0 5 50", key: "$::".concat(index), top: ~~(Math.random() * 100) + 50, left: ~~(Math.random() * 100), delay: Math.random() * 2 - 1, duration: Math.random() * 3, pathOpacity: Math.random(), transformRandom: Math.random(), parentHeight: parentHeight },
                react_1.default.createElement("path", { stroke: "none", d: "M 2.5,0 C 2.6949458,3.5392017 3.344765,20.524571 4.4494577,30.9559 5.7551357,42.666753 4.5915685,50 2.5,50 0.40843152,50 -0.75513565,42.666753 0.55054234,30.9559 1.655235,20.524571 2.3050542,3.5392017 2.5,0 Z" })));
        }),
        children));
};
exports.default = Rainy;
